var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          staticClass: "paper-dialog",
          attrs: {
            title: "Edit Paper",
            visible: _vm.dialogVisible,
            width: "65vw",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.onOpen,
            close: _vm.onClosed,
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              staticClass: "padding-lr",
              attrs: {
                model: _vm.form,
                rules: _vm.formRules,
                "label-width": "190px",
                "element-loading-text": "loading...",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "", prop: "" } }, [
                _c("p", { staticClass: "right-find" }, [
                  _c("i", { staticClass: "el-icon-warning-outline" }),
                  _vm._v(
                    "请务必确保礼来有使用以下内容的版权，如需查询，烦请使用VPN登录此网站： "
                  ),
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.rightfind.com",
                        target: "_blank",
                      },
                    },
                    [_vm._v("https://www.rightfind.com")]
                  ),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Content Category", prop: "categoryId" } },
                [
                  _c(
                    "div",
                    { staticClass: "cate-select-add" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "Please select content category",
                          },
                          model: {
                            value: _vm.form.categoryId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "categoryId", $$v)
                            },
                            expression: "form.categoryId",
                          },
                        },
                        _vm._l(_vm.categoryList, function (item, index) {
                          return _c(
                            "el-option",
                            {
                              key: index,
                              attrs: {
                                label: item.CategoryName,
                                value: item.PaperCategoryID,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "select-option-item",
                                  attrs: { title: item.CategoryName },
                                },
                                [_vm._v(" " + _vm._s(item.CategoryName) + " ")]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _c("el-button", {
                        attrs: { icon: "el-icon-plus" },
                        on: { click: _vm.showCateDialog },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Short Title", prop: "shortTitle" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input short title",
                      maxlength: "100",
                    },
                    model: {
                      value: _vm.form.shortTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "shortTitle", $$v)
                      },
                      expression: "form.shortTitle",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Search Term", prop: "searchTerm" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "Please input search term",
                      maxlength: "40",
                    },
                    model: {
                      value: _vm.form.searchTerm,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "searchTerm", $$v)
                      },
                      expression: "form.searchTerm",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Security Level", prop: "levelID" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Please select security level" },
                      model: {
                        value: _vm.form.levelID,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "levelID", $$v)
                        },
                        expression: "form.levelID",
                      },
                    },
                    _vm._l(_vm.securityLevels, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.Name, value: item.Id },
                      })
                    }),
                    1
                  ),
                  _c("p", { staticClass: "security-level" }, [
                    _c("i", { staticClass: "el-icon-warning-outline" }),
                    _vm._v("本平台禁止传输Orange/Red CCI文件。 "),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "replace-file",
                  attrs: { label: "PDF Attached", prop: "isReplace" },
                },
                [
                  _c("el-checkbox", {
                    model: {
                      value: _vm.form.isReplace,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isReplace", $$v)
                      },
                      expression: "form.isReplace",
                    },
                  }),
                  _c("div", { staticClass: "replace-file-tip" }, [
                    _c("span", [_vm._v("Replace Uploaded File ?")]),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.previewUrl,
                          target: "_blank",
                          title: _vm.previewName,
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.previewName) + " ")]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Upload PDF" } },
                [
                  _c("FileUpload", {
                    ref: "fileUpload",
                    attrs: {
                      action: "/content/uploadFile",
                      accept: ".PDF,.pdf",
                      message: "Only PDF file can be uploaded",
                    },
                    on: { success: _vm.handleSuccess, fail: _vm.handleFail },
                  }),
                  _vm.uploadFile
                    ? _c("div", { staticClass: "upload-file" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.uploadFile.url,
                              target: "_blank",
                              title: _vm.fileName,
                            },
                          },
                          [
                            _c("i", { staticClass: "el-icon-document" }),
                            _vm._v(" " + _vm._s(_vm.fileName) + " "),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                _vm.uploadFile = null
                              },
                            },
                          },
                          [_c("i", { staticClass: "el-icon-close" })]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "Allow Full Article Request",
                    prop: "fullPaperRequest",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.fullPaperRequest,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fullPaperRequest", $$v)
                        },
                        expression: "form.fullPaperRequest",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("Yes")]),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("No")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "editor",
                  attrs: { label: "Content", prop: "paperContent" },
                },
                [
                  _vm.visible
                    ? _c("TinymceEditor", {
                        ref: "vTinymce",
                        attrs: { height: 300 },
                        on: { input: _vm.paperContentValidator },
                        model: {
                          value: _vm.form.paperContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "paperContent", $$v)
                          },
                          expression: "form.paperContent",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "push-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v(" Submit ")]
              ),
              _c(
                "el-button",
                { attrs: { plain: "" }, on: { click: _vm.onClosed } },
                [_vm._v(" Cancel ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("NewCategoryDialog", {
        attrs: { visible: _vm.addCategoryDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.addCategoryDialogVisible = $event
          },
          success: _vm.onNewCateSuccess,
          closed: _vm.onNewCateClosed,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }